import { render, staticRenderFns } from "./ElementsTable.vue?vue&type=template&id=15a8b96b"
import script from "./ElementsTable.vue?vue&type=script&lang=js"
export * from "./ElementsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports